/* ===========================================================================
   STHEEL — Free socks per iscritti newsletter                          v3.3.0
   ---------------------------------------------------------------------------
   Aggiunge i calzini al carrello quando è ATTIVO un codice sconto di benvenuto,
   e li toglie quando non lo è più.

   v3: NON sostituisce più window.fetch né XMLHttpRequest. Su store con app che
   fanno lo stesso (PageFly, shop-cart-sync di Shopify, ecc.) le catene di
   wrapper possono impedire alla richiesta di ATC di risolversi → spinner
   infinito. Ora le modifiche al carrello si rilevano con un PerformanceObserver
   passivo, che non può interferire con nessuna richiesta.

   Cosa conta come "sconto attivo", in ordine di affidabilità:
     1. /cart.js espone discount_codes: [{code, applicable}] — è Shopify stesso
        a dirci se il codice in sessione è valido per questo carrello
     2. l'utente è arrivato con ?discount=CODICE (link dell'email Klaviyo)
     3. il cookie discount_code, se leggibile
     4. submit del popup Klaviyo: se popupCode è impostato lo applichiamo noi
        alla sessione e i calzini entrano subito nel carrello (v3.1)
   Il codice deve corrispondere a codePatterns, così un saldo qualunque non
   regala i calzini.

   ⚠️ Chi azzera il prezzo è lo SCONTO CONFIGURATO IN SHOPIFY, non questo file.
   Con requireFreeLine: true lo script verifica che lo sconto copra davvero il
   regalo e, se non lo copre, rimuove la riga: il cliente non paga mai i calzini
   per uno sconto scaduto o mal configurato.
   =========================================================================== */
(function () {
  'use strict';

  var VERSION = '3.3.0';

  // ======================= CONFIGURAZIONE =======================
  // Sovrascrivi da theme.liquid definendo window.STHEEL_GIFT_CONFIG
  // PRIMA di caricare questo file.
  var CONFIG = {
    // ID DELLA VARIANTE dei calzini (NON del prodotto). Passalo da Liquid:
    //   {%- assign p = all_products['stheel-work-socks'] -%}
    //   {%- assign v = p.variants | where: 'title', '1 Pair' | first -%}
    // Non usare first_available_variant: se "1 Pair" si esaurisce diventa
    // "2 Pairs" e regali il doppio.
    // Se è 0 lo script si disattiva del tutto e non tocca niente.
    giftVariantId: 0,

    // ---- Trigger ----------------------------------------------------------
    // 'discount' = serve un codice di benvenuto attivo (consigliato)
    // 'any'      = sblocca anche col solo submit del popup o con ?gift=1
    triggerMode: 'discount',

    // Quali codici sbloccano l'omaggio. Regex, case-insensitive.
    // Klaviyo genera codici unici tipo STHEELSOCKS01-A1B2C3 → basta il prefisso.
    // In test: ['^WELCOME10$'] (è un 10% sull'ordine, non copre il regalo:
    // serve anche requireFreeLine: 'warn').
    codePatterns: ['^STHEELSOCKS'],

    // Codice statico mostrato nel popup Klaviyo, per chi compra subito senza
    // aspettare l'email. '' = disattivato. Deve corrispondere a codePatterns.
    popupCode: '',

    // Per quanti giorni ricordiamo il codice
    ttlDays: 30,

    // Ri-applica il codice alla sessione Shopify (una volta per sessione)
    primeSession: true,

    // Passa da /discount/CODICE?redirect=/checkout al click su "Checkout".
    // DEFAULT OFF: intercetta i click, ed è la parte più invasiva del file.
    // Accendilo solo se vedi ordini senza sconto.
    forceCodeOnCheckout: false,

    // ---- Condizioni carrello ---------------------------------------------
    // Subtotale minimo degli ALTRI prodotti (calzini esclusi), in centesimi.
    // DEVE combaciare con il minimo d'ordine dello sconto Shopify: se lo script
    // aggiunge l'omaggio prima che lo sconto scatti, la guardia lo rimuove.
    // 5000 = 50,00 · 0 = nessun minimo
    minSubtotal: 0,

    // ---- Guardia prezzo --------------------------------------------------
    // Verifica che lo sconto Shopify copra almeno un'unità di omaggio.
    // true   = se non lo copre, rimuove la riga (produzione)
    // 'warn' = lascia la riga e logga (collaudo)
    // false  = nessun controllo
    requireFreeLine: true,
    freeLineTolerance: 0,

    // ---- Aggiornamento interfaccia ---------------------------------------
    // 'auto' | 'sections' | 'events' | 'reload'
    refreshMode: 'auto',
    // LASCIALO VUOTO: su Radiant e sui temi con template JSON gli ID sezione
    // contengono l'ID del template e li rileviamo dal DOM. Massimo 5.
    refreshSections: [],

    // ---- Riga omaggio ----------------------------------------------------
    giftProperty: '_free_gift',
    // Proprietà VISIBILE sotto il nome, nel carrello e nel checkout.
    // null = disattivata. es. { name: 'Welcome gift', value: '🎁 Free gift' }
    giftLabel: null,

    // ---- Rotte (passale da Liquid se hai mercati multipli) ----------------
    root: '/',
    cartUrl: '/cart',

    debug: false
  };

  if (window.STHEEL_GIFT_CONFIG) {
    Object.keys(window.STHEEL_GIFT_CONFIG).forEach(function (k) {
      CONFIG[k] = window.STHEEL_GIFT_CONFIG[k];
    });
  }
  if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
    if (CONFIG.root === '/') CONFIG.root = window.Shopify.routes.root;
  }
  if (CONFIG.root.slice(-1) !== '/') CONFIG.root += '/';
  // ==============================================================

  var K_CODE     = 'stheel_gift_code';
  var K_DECLINED = 'stheel_gift_declined';
  var K_LASTSEEN = 'stheel_gift_lastseen';
  var K_PRIMED   = 'stheel_gift_primed';
  var K_PRICEKO  = 'stheel_gift_priceko';
  var K_RELOADED = 'stheel_gift_reloaded';

  var busy = false;
  var pending = false;
  var lastOwnRequest = 0;   // per ignorare le nostre stesse chiamate
  var warnedPrice = false;
  var warnedCode = false;
  var priceFailures = 0;   // tentativi di grazia prima di arrendersi
  var qualifyingSubtotal = 0;   // subtotale degli altri prodotti, ultimo sync
  var sectionCache = { path: null, list: null };

  function log() {
    if (CONFIG.debug) console.log.apply(console, ['[free-gift]'].concat([].slice.call(arguments)));
  }

  // Tutto ciò che gira dentro callback del tema passa da qui: un'eccezione
  // nostra non deve mai propagarsi nel codice di qualcun altro.
  function safe(fn) {
    return function () {
      try { return fn.apply(this, arguments); }
      catch (e) { log('errore ignorato:', e); }
    };
  }

  function store(key, val) {
    try {
      if (val === undefined) return localStorage.getItem(key);
      if (val === null) localStorage.removeItem(key);
      else localStorage.setItem(key, val);
    } catch (e) { /* Safari privato */ }
    return null;
  }

  function sess(key, val) {
    try {
      if (val === undefined) return sessionStorage.getItem(key);
      if (val === null) sessionStorage.removeItem(key);
      else sessionStorage.setItem(key, val);
    } catch (e) { /* idem */ }
    return null;
  }

  // ---------- Codice sconto ----------
  function codeAllowed(code) {
    if (!code) return false;
    if (!CONFIG.codePatterns || !CONFIG.codePatterns.length) return true;
    return CONFIG.codePatterns.some(function (p) {
      try { return new RegExp(p, 'i').test(code); } catch (e) { return false; }
    });
  }

  function readCookie(name) {
    try {
      var m = String(document.cookie || '')
        .match('(?:^|;)\\s*' + name + '\\s*=\\s*([^;]*)');
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) { return null; }
  }

  function detectCode() {
    var code = null;
    try { code = new URLSearchParams(location.search).get('discount'); }
    catch (e) { /* URL sporco */ }
    if (!code) {
      var m = String(location.pathname).match(/\/discount\/([^/?#]+)/i);
      if (m) { try { code = decodeURIComponent(m[1]); } catch (e) { code = m[1]; } }
    }
    if (!code) code = readCookie('discount_code');
    return code ? String(code).trim() : null;
  }

  /* Shopify espone in /cart.js i codici in sessione con il flag `applicable`,
     validato lato server: è il segnale di gate più affidabile.
     Nota: un codice "Compra X ottieni Y" può risultare non applicabile finché
     il prodotto omaggio non è nel carrello, quindi la sua assenza non prova
     nulla — non blocchiamo, ci pensa la guardia prezzo. */
  function applicableCode(cart) {
    var codes = (cart && cart.discount_codes) || [];
    var rejected = null;
    for (var i = 0; i < codes.length; i++) {
      if (!codeAllowed(codes[i].code)) continue;
      if (codes[i].applicable) return codes[i].code;
      rejected = codes[i].code;
    }
    if (rejected && !warnedCode) {
      warnedCode = true;
      console.warn('[free-gift] il codice ' + rejected + ' è in sessione ma Shopify ' +
        'lo dà come non applicabile a questo carrello (scaduto, già usato, ' +
        'condizioni non soddisfatte o inesistente).');
    }
    return null;
  }

  function savedCode() {
    var raw = store(K_CODE);
    if (!raw) return null;
    var rec;
    try { rec = JSON.parse(raw); } catch (e) { return null; }
    if (!rec || !rec.exp || rec.exp < Date.now()) { store(K_CODE, null); return null; }
    if (CONFIG.triggerMode === 'discount' && !codeAllowed(rec.code)) return null;
    return rec;
  }

  function grant(code, source) {
    if (CONFIG.triggerMode === 'discount' && !codeAllowed(code)) {
      log('codice ignorato (' + source + '):', code);
      return false;
    }
    store(K_CODE, JSON.stringify({
      code: code || null,
      exp: Date.now() + CONFIG.ttlDays * 86400000
    }));
    store(K_DECLINED, null);
    sess(K_PRICEKO, null);
    warnedPrice = false;
    warnedCode = false;
    priceFailures = 0;
    log('sbloccato da', source, '→', code);
    if (code) primeSession(code);
    return true;
  }

  // Applica il codice alla sessione Shopify senza navigare via.
  // Una volta per sessione: è una richiesta HTML, non è gratis.
  function primeSession(code) {
    if (!CONFIG.primeSession || !code) return;
    if (sess(K_PRIMED) === code) return;
    sess(K_PRIMED, code);
    applyCodeToSession(code).catch(function () { sess(K_PRIMED, null); });
  }

  /* Applica un codice alla sessione Shopify senza navigare via.
     È anche l'API pubblica per un campo sconto nel carrello:
     STHEELGift.applyCode('STHEELSOCKS01') */
  function applyCodeToSession(code) {
    if (!code) return Promise.reject(new Error('codice mancante'));
    lastOwnRequest = Date.now();
    try {
      return fetch(CONFIG.root + 'discount/' + encodeURIComponent(code), {
        credentials: 'same-origin',
        redirect: 'follow'
      }).then(function () {
        lastOwnRequest = Date.now();
        log('codice applicato alla sessione:', code);
        return true;
      });
    } catch (e) { return Promise.reject(e); }
  }

  function isEligible() {
    if (store(K_DECLINED) === '1') return false;
    if (sess(K_PRICEKO) !== null) return false;   // ci siamo arresi su questo carrello
    return !!savedCode();
  }

  // ---------- Sezioni carrello ----------
  /* Gli ID non sono scrivibili a mano: su Radiant e sugli altri temi con
     template JSON contengono l'ID del template
     (es. template--25003500241232__cart-items). Li troviamo nel DOM.
     La Section Rendering API ne accetta massimo 5. */
  function discoverCartSections() {
    var out = [];
    try {
      var nodes = document.querySelectorAll('[id^="shopify-section-"]');
      for (var i = 0; i < nodes.length && out.length < 5; i++) {
        var id = nodes[i].id.replace('shopify-section-', '');
        var relevant = /cart/i.test(id) || (nodes[i].querySelector && nodes[i].querySelector(
          'cart-drawer, cart-drawer-items, cart-items, [id*="cart-icon-bubble"], .cart-count-bubble'
        ));
        if (relevant) out.push(id);
      }
    } catch (e) { /* niente */ }
    return out;
  }

  function cartSections() {
    if (CONFIG.refreshSections && CONFIG.refreshSections.length) return CONFIG.refreshSections;
    if (sectionCache.path === location.pathname && sectionCache.list) return sectionCache.list;
    var list = discoverCartSections();
    sectionCache = { path: location.pathname, list: list };
    log('sezioni carrello rilevate:', list.length ? list.join(', ') : 'nessuna');
    return list;
  }

  // ---------- API carrello ----------
  function withSections(payload) {
    if (CONFIG.refreshMode === 'events' || CONFIG.refreshMode === 'reload') return payload;
    var list = cartSections();
    if (list.length) {
      payload.sections = list.join(',');
      payload.sections_url = location.pathname + location.search;
    }
    return payload;
  }

  function getCart() {
    lastOwnRequest = Date.now();
    return fetch(CONFIG.cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function cartPost(url, payload) {
    busy = true;
    lastOwnRequest = Date.now();
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(withSections(payload))
    }).then(function (r) {
      lastOwnRequest = Date.now();
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    }).finally(function () {
      lastOwnRequest = Date.now();
      busy = false;
    });
  }

  function giftProps() {
    var props = {};
    props[CONFIG.giftProperty] = 'true';
    if (CONFIG.giftLabel && CONFIG.giftLabel.name) {
      props[CONFIG.giftLabel.name] = CONFIG.giftLabel.value || '';
    }
    return props;
  }

  function addGift() {
    log('aggiungo omaggio');
    return cartPost(CONFIG.cartUrl + '/add.js', {
      items: [{ id: CONFIG.giftVariantId, quantity: 1, properties: giftProps() }]
    });
  }

  function removeGift(key) {
    log('rimuovo omaggio');
    return cartPost(CONFIG.cartUrl + '/change.js', { id: key, quantity: 0 });
  }

  function fixGiftQty(key) {
    log('riporto omaggio a quantità 1');
    return cartPost(CONFIG.cartUrl + '/change.js', { id: key, quantity: 1 });
  }

  // ---------- Riga omaggio ----------
  /* Si riconosce SOLO dalla proprietà nascosta, non dal variant_id: la stessa
     variante può essere acquistata davvero dal cliente, e Shopify tiene le due
     righe separate proprio perché hanno proprietà diverse. Riconoscerla per
     variante vorrebbe dire confondere un acquisto con il regalo e forzargli
     la quantità a 1. */
  function isGiftLine(item) {
    return !!(item.properties && item.properties[CONFIG.giftProperty]);
  }

  /* Campi prezzo di /cart.js, misurati su stheel.com:
       original_line_price  listino                      (1990)
       final_line_price     dopo i soli sconti di LINEA  (1990 con un codice ordine!)
       line_price           dopo TUTTI gli sconti        (1791)
       total_discount       sconto allocato alla riga    (199)  ← il più affidabile
     Usare final_line_price da solo significa non vedere gli sconti di ordine. */
  function lineDiscount(i) {
    if (typeof i.total_discount === 'number') return i.total_discount;
    var original = typeof i.original_line_price === 'number'
      ? i.original_line_price : (i.price || 0) * i.quantity;
    var charged = original;
    if (typeof i.line_price === 'number') charged = Math.min(charged, i.line_price);
    if (typeof i.final_line_price === 'number') charged = Math.min(charged, i.final_line_price);
    return Math.max(0, original - charged);
  }

  function lineCharged(i) {
    var original = typeof i.original_line_price === 'number'
      ? i.original_line_price : (i.price || 0) * i.quantity;
    return Math.max(0, original - lineDiscount(i));
  }

  /* Se il cliente compra anche lui dei calzini, Shopify può allocare l'unità
     gratis sulla riga acquistata invece che sulla nostra: sommiamo lo sconto su
     tutte le righe della variante omaggio e controlliamo che copra un'unità. */
  function giftDiscountCoversUnit(cart, gift) {
    var unit = gift.original_price || gift.price || 0;
    if (!unit) return true;
    var saved = 0, titles = [];
    (cart.items || []).forEach(function (i) {
      if (i.variant_id !== gift.variant_id) return;
      saved += lineDiscount(i);
      (i.discounts || []).forEach(function (d) { titles.push(d.title); });
    });
    log('sconto sulle righe omaggio:', saved, '/', unit,
        titles.length ? '(' + titles.join(', ') + ')' : '(nessuno)');
    return saved + CONFIG.freeLineTolerance >= unit;
  }

  function enforceFreePrice(cart, gift) {
    if (!CONFIG.requireFreeLine || giftDiscountCoversUnit(cart, gift)) {
      priceFailures = 0;
      return Promise.resolve(false);
    }
    if (!warnedPrice) {
      warnedPrice = true;
      console.warn('[free-gift] lo sconto non copre l\'omaggio: sconto allocato ' +
        lineDiscount(gift) + ' centesimi su ' + (gift.original_price || gift.price) +
        ' di listino. Controlla lo sconto in Shopify o la validità del codice.');
    }
    if (CONFIG.requireFreeLine !== true) return Promise.resolve(false);

    /* Un tentativo di grazia: l'applicazione di un codice è asincrona, e al
       primo giro lo sconto può non essere ancora in sessione. Rimuoviamo la
       riga ma restiamo idonei; ci arrendiamo solo al secondo fallimento. */
    priceFailures++;
    if (priceFailures >= 2) sess(K_PRICEKO, String(qualifyingSubtotal));
    else log('sconto non ancora visto: riprovo una volta');
    store(K_LASTSEEN, '0');
    return removeGift(gift.key).then(function (res) {
      refreshUI(res);
      return true;
    });
  }

  // ---------- Logica principale ----------
  function sync() {
    if (busy) { pending = true; return Promise.resolve(); }

    return getCart().then(function (cart) {
      var gift = null, otherItems = 0, otherSubtotal = 0;

      (cart.items || []).forEach(function (item) {
        if (isGiftLine(item)) gift = item;
        else {
          otherItems += item.quantity;
          otherSubtotal += lineCharged(item);
        }
      });

      var fromCart = applicableCode(cart);
      if (fromCart) {
        var known = savedCode();
        // non ri-concediamo lo stesso codice: azzererebbe il flag "sconto rotto"
        // a ogni sync e l'omaggio entrerebbe in loop aggiungi/rimuovi
        if (!known || known.code !== fromCart) grant(fromCart, 'cart.discount_codes');
      }

      qualifyingSubtotal = otherSubtotal;

      /* Se ci eravamo arresi ma il carrello è cresciuto, riprovaci: tipicamente
         il cliente era sotto il minimo d'ordine dello sconto e ora l'ha superato. */
      var gaveUpAt = sess(K_PRICEKO);
      if (gaveUpAt !== null && otherSubtotal > Number(gaveUpAt)) {
        sess(K_PRICEKO, null);
        priceFailures = 0;
        warnedPrice = false;
        log('carrello cresciuto da', gaveUpAt, 'a', otherSubtotal, '→ riprovo l\'omaggio');
      }

      var wasPresent = store(K_LASTSEEN) === '1';
      var shouldHave = isEligible() && otherItems > 0 && otherSubtotal >= CONFIG.minSubtotal;

      // L'utente l'ha tolto a mano → rispettiamo la scelta
      if (wasPresent && !gift && shouldHave) {
        log('rimosso dall\'utente → non lo rimetto');
        store(K_DECLINED, '1');
        store(K_LASTSEEN, '0');
        return;
      }

      if (gift && shouldHave) {
        store(K_LASTSEEN, '1');
        if (gift.quantity !== 1) {
          // prima la quantità: con BXGY solo 1 unità è scontata, il controllo
          // prezzo su una riga da 4 pezzi sarebbe fuorviante
          return fixGiftQty(gift.key).then(function (res) {
            refreshUI(res);
            var line = (res && res.items || []).filter(isGiftLine)[0];
            if (line) return enforceFreePrice(res, line);
          });
        }
        return enforceFreePrice(cart, gift).then(function (handled) {
          if (!handled) sess(K_RELOADED, null);
        });
      }

      var action = null;
      if (gift && !shouldHave)      action = removeGift(gift.key);
      else if (!gift && shouldHave) action = addGift();

      store(K_LASTSEEN, shouldHave ? '1' : '0');
      if (!action) { sess(K_RELOADED, null); return; }

      return action.then(function (res) {
        refreshUI(res);
        var line = (res && res.items || []).filter(isGiftLine)[0];
        if (line) return enforceFreePrice(res, line);
      }).catch(function (err) {
        console.warn('[free-gift] operazione carrello fallita:', err);
      });
    }).catch(function (err) {
      log('sync fallito:', err);
    }).finally(function () {
      if (pending) { pending = false; setTimeout(sync, 150); }
    });
  }

  var syncTimer = null;
  function syncSoon(delay) {
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(function () { syncTimer = null; sync(); }, delay || 150);
  }

  // ---------- Aggiornamento interfaccia ----------
  function applySections(json) {
    if (!json || !json.sections) return false;
    var applied = false;
    Object.keys(json.sections).forEach(function (id) {
      var html = json.sections[id];
      if (!html) return;
      var target = document.getElementById('shopify-section-' + id);
      if (!target) return;
      try {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('shopify-section-' + id) || doc.body.firstElementChild;
        if (!fresh) return;
        target.innerHTML = fresh.innerHTML;
        applied = true;
      } catch (e) { /* si passa al fallback */ }
    });
    if (applied) log('sezioni ri-renderizzate');
    return applied;
  }

  function dispatchThemeEvents() {
    ['cart:refresh', 'cart:updated', 'cart:build', 'cart:change'].forEach(function (name) {
      try {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
        if (document.body) document.body.dispatchEvent(new CustomEvent(name, { bubbles: true }));
      } catch (e) { /* CustomEvent assente */ }
    });
  }

  function onCartPage() {
    return String(location.pathname).indexOf(CONFIG.cartUrl) === 0;
  }

  function refreshUI(json) {
    var mode = CONFIG.refreshMode;

    if (mode === 'sections' || mode === 'auto') {
      if (applySections(json)) { if (mode === 'sections') return; }
      else if (mode === 'sections') { log('sezioni non applicate'); return; }
    }
    if (mode !== 'reload') dispatchThemeEvents();

    if ((mode === 'reload' || mode === 'auto') && onCartPage()) {
      if (sess(K_RELOADED) === '1') return;   // guardia anti-loop
      sess(K_RELOADED, '1');
      location.reload();
    }
  }

  // ---------- Trigger 1: codice nell'URL / nel cookie ----------
  function rescanUrl() {
    var code = detectCode();
    if (code && codeAllowed(code)) {
      var saved = savedCode();
      if (!saved || saved.code !== code) return grant(code, 'url');
      primeSession(code);
      return true;
    }
    if (code) log('codice presente ma non abilitato:', code);
    return false;
  }

  // ---------- Trigger 2: submit del popup Klaviyo ----------
  /* Iscrizione dal popup Klaviyo → omaggio immediato.
     Ordine importante: PRIMA applichiamo il codice alla sessione Shopify, POI
     aggiungiamo i calzini. Al contrario la guardia prezzo vedrebbe la riga a
     prezzo pieno (lo sconto non è ancora in sessione) e la rimuoverebbe. */
  function hookKlaviyo() {
    window.addEventListener('klaviyoForms', safe(function (e) {
      if (!e || !e.detail || e.detail.type !== 'submit') return;
      var code = CONFIG.popupCode || null;
      log('iscrizione Klaviyo registrata', code ? '→ applico ' + code : '(nessun popupCode)');

      if (!code) {
        // senza popupCode serve uno sconto AUTOMATICO in Shopify, e
        // triggerMode: 'any', altrimenti aspettiamo il link dell'email
        if (CONFIG.triggerMode === 'discount') {
          log('popupCode non impostato: aspetto il link email');
          return;
        }
        if (grant(null, 'klaviyo')) recheckAfterCode();
        return;
      }

      /* Ordine critico: PRIMA salviamo l'entitlement (localStorage, sincrono),
         POI applichiamo il codice. Se il popup fa un redirect dopo l'iscrizione,
         la fetch viene annullata: con l'ordine inverso perderemmo il diritto
         all'omaggio. Così invece al pageview successivo primeSession riapplica
         il codice e sync() aggiunge i calzini. */
      sess(K_PRIMED, code);   // blocca il primeSession interno di grant()
      if (!grant(code, 'klaviyo')) { sess(K_PRIMED, null); return; }

      applyCodeToSession(code).then(function () {
        return sync();
      }).catch(function () {
        sess(K_PRIMED, null);
        recheckAfterCode();
      });
    }));
  }

  // ---------- Trigger 3 (solo triggerMode 'any'): ?gift=1 ----------
  function hookLegacyParam() {
    if (CONFIG.triggerMode === 'discount') return;
    try {
      if (new URLSearchParams(location.search).get('gift') === '1') {
        grant(CONFIG.popupCode || null, 'gift-param');
      }
    } catch (e) { /* niente */ }
  }

  /* ---------- Trigger 4: modifiche al carrello, in modo PASSIVO ----------
     Niente wrapper su window.fetch / XMLHttpRequest: su store con PageFly,
     shop-cart-sync e altre app che patchano fetch, le catene di wrapper
     possono impedire alla richiesta di ATC di risolversi (spinner infinito).
     Il PerformanceObserver vede le stesse richieste senza toccarle. */
  function watchCartRequests() {
    // anche /discount/CODICE: è così che i temi e le app applicano un codice
    // digitato in un campo sconto, senza toccare il carrello
    var CART_RE = /\/(cart\/(add|change|update|clear)(\.js)?|discount\/)/;
    var observed = false;

    if (typeof PerformanceObserver !== 'undefined') {
      try {
        var obs = new PerformanceObserver(safe(function (list) {
          var hit = false;
          list.getEntries().forEach(function (entry) {
            if (!CART_RE.test(entry.name || '')) return;
            if (Date.now() - lastOwnRequest < 800) return;  // era una nostra chiamata
            hit = true;
          });
          if (hit) syncSoon(250);
        }));
        obs.observe({ type: 'resource', buffered: true });
        observed = true;
        log('osservatore richieste: PerformanceObserver');
      } catch (e) { observed = false; }
    }

    if (!observed) {
      // fallback senza patch: dopo ogni click diamo un'occhiata al carrello
      log('osservatore richieste: fallback su click');
      document.addEventListener('click', safe(function () { syncSoon(900); }), true);
    }

    // contratto standard dei temi (Shopify Spring '26): lo ascoltiamo, non lo emettiamo
    document.addEventListener('shopify:cart:lines-update', safe(function () { syncSoon(250); }));

    // ritorno da back/forward cache
    window.addEventListener('pageshow', safe(function (e) { if (e && e.persisted) syncSoon(300); }));
  }

  /* ---------- Campo sconto nel carrello ----------
     L'applicazione di un codice è asincrona e non passa dal carrello, quindi
     ricontrolliamo più volte dopo l'interazione. Funziona con il campo nostro
     (data-gift-discount-form) e con quelli di tema o app. */
  function recheckAfterCode() {
    [400, 1200, 2500].forEach(function (ms) { setTimeout(safe(sync), ms); });
  }

  function watchDiscountFields() {
    var SEL = '[data-gift-discount-input], input[name="discount"], ' +
              'input[name*="discount"], input[id*="discount"], input[name*="coupon"]';

    document.addEventListener('submit', safe(function (ev) {
      var f = ev.target;
      if (f && f.querySelector && f.querySelector(SEL)) recheckAfterCode();
    }), true);

    document.addEventListener('click', safe(function (ev) {
      var el = ev.target && ev.target.closest ? ev.target.closest('button, a') : null;
      if (!el) return;
      var form = el.closest ? el.closest('form') : null;
      var isApply = (form && form.querySelector && form.querySelector(SEL)) ||
        /apply|applica|coupon|discount|sconto|promo/i.test(el.textContent || '');
      if (isApply) recheckAfterCode();
    }), true);

    document.addEventListener('keydown', safe(function (ev) {
      if (ev.key !== 'Enter') return;
      var t = ev.target;
      if (t && t.matches && t.matches(SEL)) recheckAfterCode();
    }), true);

    // il nostro campo, se presente nel tema
    document.addEventListener('submit', safe(function (ev) {
      var f = ev.target;
      if (!f || !f.hasAttribute || !f.hasAttribute('data-gift-discount-form')) return;
      ev.preventDefault();
      var input = f.querySelector('[data-gift-discount-input]');
      var msg = f.querySelector('[data-gift-discount-message]');
      var code = input && input.value ? input.value.trim() : '';
      if (!code) return;
      if (msg) msg.textContent = '';
      f.setAttribute('aria-busy', 'true');
      applyCodeToSession(code).then(function () {
        if (codeAllowed(code)) grant(code, 'campo carrello');
        return sync();
      }).then(function () {
        // /cart.js dice se Shopify lo ha accettato
        return getCart();
      }).then(function (cart) {
        var found = (cart.discount_codes || []).filter(function (d) {
          return String(d.code).toUpperCase() === code.toUpperCase();
        })[0];
        if (msg) {
          msg.textContent = found && found.applicable
            ? 'Code applied.'
            : 'This code is not valid for your cart.';
        }
        if (found && found.applicable) recheckAfterCode();
      }).catch(function (e) {
        log('campo sconto:', e);
        if (msg) msg.textContent = 'Something went wrong, try again.';
      }).then(function () {
        f.removeAttribute('aria-busy');
      });
    }), true);
  }

  // ---------- Garanzia codice al checkout (opzionale) ----------
  function checkoutUrl() {
    var rec = savedCode();
    if (!rec || !rec.code) return null;
    return CONFIG.root + 'discount/' + encodeURIComponent(rec.code) +
      '?redirect=' + encodeURIComponent('/checkout');
  }

  function hookCheckoutButtons() {
    if (!CONFIG.forceCodeOnCheckout) return;
    // bolla, non cattura, e senza stopPropagation: se il tema ha già un suo
    // handler sul bottone, lo lasciamo lavorare
    document.addEventListener('click', safe(function (ev) {
      if (ev.defaultPrevented) return;
      var el = ev.target && ev.target.closest
        ? ev.target.closest('[name="checkout"], a[href$="/checkout"]')
        : null;
      if (!el || el.hasAttribute('data-gift-ignore')) return;
      if (el.closest('form[action*="/cart/add"]')) return;   // mai un form prodotto
      var url = checkoutUrl();
      if (!url) return;
      ev.preventDefault();
      log('checkout via', url);
      window.location.href = url;
    }));
  }

  // ---------- Avvio ----------
  function init() {
    // Senza variante omaggio lo script non deve fare NULLA: nessun listener,
    // nessuna richiesta. Meglio inerte che invasivo.
    if (!CONFIG.giftVariantId) {
      console.warn('[free-gift] giftVariantId non configurato: script disattivato.');
      return;
    }
    log('v' + VERSION, 'triggerMode:', CONFIG.triggerMode);
    hookKlaviyo();
    watchCartRequests();
    watchDiscountFields();
    hookCheckoutButtons();
    hookLegacyParam();
    rescanUrl();
    var rec = savedCode();
    if (rec && rec.code) primeSession(rec.code);
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safe(init));
  } else {
    safe(init)();
  }

  // per il collaudo da console
  window.STHEELGift = {
    version: VERSION,
    sync: sync,
    rescanUrl: rescanUrl,
    grant: function (code) { return grant(code || CONFIG.popupCode || 'STHEELSOCKS01', 'manuale'); },
    checkoutUrl: checkoutUrl,
    reset: function () {
      store(K_CODE, null); store(K_DECLINED, null); store(K_LASTSEEN, null);
      sess(K_PRIMED, null); sess(K_PRICEKO, null); sess(K_RELOADED, null);
      warnedPrice = false; warnedCode = false; priceFailures = 0;
      sectionCache = { path: null, list: null };
      log('stato azzerato');
    },
    state: function () {
      var rec = savedCode();
      return {
        eligible: isEligible(),
        code: rec ? rec.code : null,
        expires: rec ? new Date(rec.exp).toISOString() : null,
        declined: store(K_DECLINED) === '1',
        discountBroken: sess(K_PRICEKO) !== null
      };
    },
    config: CONFIG
  };
})();